import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as refValSheetActions from '../store/reference-value-sheet.actions';

@Injectable()
export class ReferenceValueSheetOverviewResolver {
  private store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  resolve(route: ActivatedRouteSnapshot) {
    const path = route.pathFromRoot
      .map((v) => v.url.map((segment) => segment.toString()).join('/'))
      .join('/');
    if (path.indexOf('standard') > -1) {
      this.store.dispatch(refValSheetActions.loadStandardRefValSheetData());
    } else {
      this.store.dispatch(refValSheetActions.loadRefValSheetData());
    }
    return of(true);
  }
}
